module.exports = __webpack_public_path__ + "static/media/record-status-in-progress.37d39705.svg";